import PubSub from "underpub-js";
import gsap from "gsap";

var ModalAlert = function (options) {

  this.options = {
    $el: false,
    baseClass: 'mol-ModalAlert',
    isToggled: false,
  };

  $.extend(true, this.options, options);

};

ModalAlert.prototype.init = function () {

  var self = this;

  self.$inner = self.options.$el.find(`.${self.options.baseClass}__inner`);
  self.$container = self.options.$el.find(`.${self.options.baseClass}__container`);
  self.$button = self.options.$el.find(`.${self.options.baseClass}__button`);
  self.$buttonClose = self.options.$el.find(`.${self.options.baseClass}__button-close`);
  self.closedCookie = `modalAlert_closed_${self.options.$el.data("current-site")}`;

  console.log(localStorage.getItem(self.closedCookie));

  PubSub.subscribe('loaded', () => {
    console.log('loaded!')
    if (localStorage.getItem(self.closedCookie) !== "true") {
      self.initAnimation();
      gsap.delayedCall(.5, () => self.toggleOn());
      console.log('show modal alert')
    }
  });
  $('[data-modal-alert-hide]').on('click', () => self.toggleOff());

  $([self.$button, self.$buttonClose]).each((index, element) => {
    $(element).on('click', () => localStorage.setItem(self.closedCookie, "true"));
  });
};

ModalAlert.prototype.initAnimation = function () {
  const self = this;

  self.timeline = gsap
    .timeline({
      paused: true,
      reversed: true,
      defaults: {
        ease: "expo.out",
        duration: .4,
      },
      onComplete: () => {
        self.toggleState();
      },
      onReverseComplete: () => {
        self.toggleState();
        gsap.set([self.$container], {
          clearProps: "all"
        });
      },
    })
    .set([self.$container], {
      clearProps: "all"
    })
    .set(self.options.$el, {
      visibility: "visible",
    })
    .fromTo(self.options.$el, {
      opacity: 0
    }, {
      opacity: 1,
    })
    .from(self.$inner, {
      y: 20,
      opacity: 0,
    }, "<.2")
    .fromTo([self.$container], {
      opacity: 0
    }, {
      opacity: 1
    }, "<")
};

ModalAlert.prototype.toggleState = function () {
  const self = this;

  self.options.isToggled = !self.options.isToggled;
};

ModalAlert.prototype.toggleOn = function (speed = 1) {
  const self = this;

  if (self.options.isToggled || self.timeline.isActive()) return;

  self.timeline.timeScale(speed).play();
};

ModalAlert.prototype.toggleOff = function (speed = 3) {
  const self = this;

  if (!self.options.isToggled || self.timeline.isActive()) return;

  self.timeline.timeScale(speed).reverse(0);
};

ModalAlert.prototype.toggle = function () {
  const self = this;

  self.timeline.reversed() ? self.toggleOn() : self.toggleOff();
};

export default ModalAlert;